export default "__VITE_ASSET__4tlzPLJ49dq8ZCn54eM03w__"